// SpinalCordIndependenceSection.js
import React from "react";
import { Phone } from "lucide-react";
import spinalCordIndependenceImage from "../assets/spinal-cord-independence-image.jpg";

const SpinalCordIndependenceSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Spinal Cord Injury Care That Fosters Independence
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                At Allawah Lodge, we understand that spinal cord injuries bring
                unique challenges that require attentive, adaptive, and
                consistent care. Our goal is to help clients rebuild confidence,
                mobility, and independence in the comfort of their own homes.
                Each care plan is thoughtfully designed to meet individual
                needs—whether that means assistance with movement, personal
                care, or emotional encouragement throughout recovery.
              </p>

              <p>
                Spinal cord injury care is about more than physical support—it's
                about empowering individuals to live with dignity and purpose
                every day. Our caregivers provide reliable help with exercises,
                daily routines, and adaptive activities that promote progress
                and stability. We also work closely with families, offering
                education, reassurance, and peace of mind as their loved one
                navigates the road to recovery.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={spinalCordIndependenceImage}
              alt="Caregiver with woman in wheelchair outdoors"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpinalCordIndependenceSection;
